export const BASE_CURRENCY = 'IDR';

export const DISPLAY_CURRENCIES = [
    { value: 'IDR', label: 'IDR (Rp)' },
    { value: 'USD', label: 'USD ($)' },
    { value: 'AUD', label: 'AUD ($)' },
    { value: 'CAD', label: 'CAD ($)' },
    { value: 'EUR', label: 'EUR (€)' },
]

export type Status = 'idle' | 'loading' | 'error' | 'loaded' | 'no-location';

export interface Filters {
  location: string;
  price_range: string;
  min_bedrooms: number | string;
  dateRange: 'day' | 'week' | 'month';
  keywords: string; // TODO: move this out of filters and treat separately
  sort: 'none' | 'pricePerMonthAsc' | 'pricePerMonthDesc';
}

export interface Coords {
  lat: number;
  lng: number;
}

export interface LocationSummary extends Coords {
  name: string;
  rentalCount: number;
}

export interface Bounds {
  ne: { lat: number; lng: number };
  sw: { lat: number; lng: number };
}

export const defaultFilters: Filters = {
  location: '',
  price_range: '',
  min_bedrooms: '',
  dateRange: 'month',
  keywords: '',
  sort: 'none',
};

export const BEDROOM_OPTIONS = ['1', '2', '3', '4', '5', '6']
  .map(n => ({ value: n, label: `${n}+` }));

export const SORT_OPTIONS = [
  { value: 'none', label: 'Sort: Default' },
  { value: 'pricePerMonthAsc', label: 'Price / Month (low)' },
  { value: 'pricePerMonthDesc', label: 'Price / Month (high)' },
];

export const PRICE_RANGE_OPTIONS = [
  { value: '11', label: 'Up to 11M' },
  { value: '15', label: 'Up to 15M' },
  { value: '25', label: 'Up to 25M' },
  { value: '38', label: 'Up to 38M' },
  { value: 'Infinity', label: 'All prices' },
];

export const DATE_RANGE_OPTIONS = [
  { value: 'day', label: 'Last 24 Hours' },
  { value: 'week', label: 'Last 7 Days' },
  { value: 'month', label: 'Last 30 Days' },
];
